export default "__VITE_ASSET__f912bf90__"